export const NOTICE_CATEGORIES = ['all', 'feature', 'event', 'store']